import { render } from "./App.vue?vue&type=template&id=5619b70c&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5619b70c&lang=css"

import exportComponent from "W:\\BPP44-PROJ\\web-project\\bpp44-vue-ts\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__